export default "__VITE_ASSET__dBiENBlX__"